export default __webpack_public_path__ + "0c2599f69dbabad8caa32adcf1c5a06f.png";